import React, { useEffect, useState, useContext, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
	Container,
	Row,
	Col,
	Form,
	Card,
	Button,
	Accordion,
	Image,
	CloseButton,
} from "react-bootstrap";
import Select from "react-select";
import Slider from "react-slick";
import InputFileWrapper from './InputFileWrapper';
import { AppContext } from "../context/appContext";

const tierServings = {
  14: 78, 
  12: 56,
  10: 38,
  8: 24,
  6: 12,
  4: 8
};

const tierConfigs = {
  6: [14, 12, 10, 8, 6, 4],
  5: [14, 12, 10, 8, 6],	
  4: [12, 10, 8, 6],
  3: [10, 8, 6],
  2: [8, 6],
  1: [8],
};

const GenericQuoteRequest = () => {
  const navigate = useNavigate();
  const { bakeryName } = "generic-quote-request"
  const { userSub, setGlobalLoading } = useContext(AppContext);

  const [bakeryPrettyName, setBakeryNamePretty] = useState("generic-quote-request");
  const [tierOptions] = useState(["1", "2", "3", "4"]); 
  const [numTiers, setNumTiers] = useState(1);
  const [tierShapeOptions, setTierShapeOptions] = useState(["round", "square", "heart"]);
  const [tierShape, setTierShape] = useState("round");
  const [cakeFlavors, setCakeFlavors] = useState({});
  const [icingFlavors, setIcingFlavors] = useState({});
  const [fillingFlavors, setFillingFlavors] = useState(["Raspberry", "Strawberry"]);
  const [cakeFlavorOptions, setCakeFlavorOptions] = useState(["Vanilla", "Chocolate"]);
  const [icingFlavorOptions, setIcingFlavorOptions] = useState(["Vanilla", "Chocolate"]);
  const [fillingFlavorOptions, setFillingFlavorOptions] = useState([]);
  const [decorations, setDecorations] = useState([]);
  const [designNotes, setDesignNotes] = useState("");
  const [availableDecorations, setAvailableDecorations] = useState([]);
  const [availableDietaryRestrictions, setAvailableDietaryRestrictions] = useState([
	"Gluten-Free", "Nut-Free", "Vegan", "Dairy-Free", "Kosher", "Egg-Free"
  ]);  
  const [selectedDietaryRestrictions, setSelectedDietaryRestrictions] = useState([]);
  const [cakePhotos, setCakePhotos] = useState([]);

  const [samplePhoto1Url, setSamplePhoto1Url] = useState(null);
  const [samplePhoto1File, setSamplePhoto1File] = useState(null);
  const [bakeryLogoUrl, setBakeryLogoUrl] = useState(null);

  const [guestEmail, setGuestEmail] = useState("");
const [guestPhone, setGuestPhone] = useState("");
const [guestEmailTouched, setGuestEmailTouched] = useState(false);

const [isSubmitting, setIsSubmitting] = useState(false);

const [samplePhotoFiles, setSamplePhotoFiles] = useState([]);
const [samplePhotoPreviews, setSamplePhotoPreviews] = useState([]);


  const [customDietaryRestriction, setCustomDietaryRestriction] = useState("");


  const getBakeryStores = useCallback(async () => {
    try {
      setGlobalLoading(true);
	  
      const response = await axios.get(
        `https://lucvle8pqe.execute-api.us-east-1.amazonaws.com/v1/getBakeries-dev?urlPathName=${bakeryName}`
      );
      if (response?.data?.bakeryStores?.length > 0) {
        const bakery = response.data.bakeryStores[0];

		setBakeryNamePretty(bakery.bakeryName);
        setTierShapeOptions(bakery.selectedShapes);
      
        setAvailableDecorations(bakery.designOptions || []);
		
		if(response?.data?.bakeryStores?.[0]?.bakeryLogoUrl) {
			setBakeryLogoUrl(response?.data?.bakeryStores?.[0]?.bakeryLogoUrl);
		}


        const tempCakePhotos = [];
        if (response?.data?.bakeryStores?.[0]?.cake1PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake1PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake2PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake2PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake3PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake3PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake4PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake4PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake5PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake5PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake6PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake6PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake7PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake7PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake8PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake8PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake9PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake9PhotoUrl);
        }
        if (response?.data?.bakeryStores?.[0]?.cake10PhotoUrl) {
          tempCakePhotos.push(response?.data?.bakeryStores?.[0]?.cake10PhotoUrl);
        }
        setCakePhotos(tempCakePhotos);



      }

      setTimeout(() => {
        setGlobalLoading(false);
      }, 2000)
    } catch (error) {
      console.error("Error fetching bakery data:", error);
    }
  }, [bakeryName, setGlobalLoading]);

  useEffect(() => {
    getBakeryStores();
  }, [getBakeryStores]);


  useEffect(() => {
    if (tierShapeOptions?.length > 0) {
      setTierShape(tierShapeOptions[0]);
		}
  }, [tierShapeOptions]);

  useEffect(() => {
	const defaultCake = cakeFlavorOptions[0];
	const defaultIcing = icingFlavorOptions[0];
  
	if (numTiers && defaultCake && defaultIcing) {
	  const newCakeFlavors = {};
	  const newIcingFlavors = {};
	  const newFillingFlavors = {};
  
	  for (let i = 1; i <= numTiers; i++) {
		newCakeFlavors[i] = { selected: defaultCake };
		newIcingFlavors[i] = { selected: defaultIcing };
		newFillingFlavors[i] = { selected: "No" };
	  }
  
	  setCakeFlavors(newCakeFlavors);
	  setIcingFlavors(newIcingFlavors);
	  setFillingFlavors(newFillingFlavors);
	}
  }, [numTiers]);
  

  const handleCakeFlavorChange = (tier, value) => {
	setCakeFlavors((prev) => ({
	  ...prev,
	  [tier]: typeof value === "string" ? { selected: value } : value,
	}));
  };
  
  const handleIcingFlavorChange = (tier, value) => {
	setIcingFlavors((prev) => ({
		...prev,
		[tier]: typeof value === "string" ? { selected: value } : value,
	}));
};

const handleFillingFlavorChange = (tier, value) => {
	setFillingFlavors((prev) => ({
		...prev,
		[tier]: typeof value === "string" ? { selected: value } : value,
	}));
};

  const getTotalServings = () => {
	const config = tierConfigs[parseInt(numTiers)];
	if (!config) return 0;
	return config.reduce((total, size) => total + (tierServings[size] || 0), 0);
  };
  

  const getPriceEstimate = () => getTotalServings() * 5;

  const handleSubmitQuote = async () => {
    try {
		if (!userSub && !guestEmail) {
			setGuestEmailTouched(true);
			alert("Please enter your email.");
			return;
		  }

			setGlobalLoading(true);
			setIsSubmitting(true);

			const uploadedFilenames = [];

			for (let i = 0; i < samplePhotoFiles.length; i++) {
			const file = samplePhotoFiles[i];
			const ext = file?.type?.split("/")[1];
			const response = await axios.get(
				`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_quote_request_sample_photo${i + 1}&ext=${ext}`
			);

			const uploadUrl = response?.data?.uploadUrl;
			await axios.put(uploadUrl, file);
			uploadedFilenames.push(response?.data?.filename);
			}

			const photoFilenames = {};
			uploadedFilenames.forEach((filename, i) => {
			photoFilenames[`samplePhoto${i + 1}Filename`] = filename;
			});


			const payload = {
				  
				...(userSub && { userSub }),
				...(!userSub && { guestEmail, guestPhone }),
				...photoFilenames,
				urlPathName: "generic-quote-request",
				numTiers,
				tierShape,
				cakeFlavors: Object.fromEntries(
					Object.entries(cakeFlavors).map(([tier, val]) => [
					  tier,
					  val.custom?.trim() || val.selected || "Not selected",
					])
				  ) ,
				  icingFlavors: Object.fromEntries(
					Object.entries(icingFlavors).map(([tier, val]) => [
					  tier,
					  val.custom?.trim() || val.selected || "Not selected",
					])
				  ),
				  fillingFlavors: Object.fromEntries(
					Object.entries(fillingFlavors).map(([tier, val]) => [
					  tier,
					  val.custom?.trim() || val.selected || "Not selected",
					])
				  ),				  
				decorations : decorations.length ? [decorations] : [],
				dietaryRestrictions: selectedDietaryRestrictions,
				designNotes,
			};

			console.log("Payload being sent:", payload);


			const response = await axios.post(
				"https://sit48d9es3.execute-api.us-east-1.amazonaws.com/v1/orderBakeries-dev",
				payload,
				{ headers: { "Content-Type": "application/json" } }
			);

			alert(response?.data?.message);
			setGlobalLoading(false);
			setIsSubmitting(false);
		} catch (error) {
			console.error("Error submitting data:", error);
			alert("There was an error submitting your inquiry.");
			setGlobalLoading(false);
		}
  };

	const sliderSettings = {
		// dots: true,
		speed: 1000,
		slidesToShow: 3,
		slidesToScroll: 3,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 750,
	};

  return (
			<Container className="py-5">
				{bakeryLogoUrl && (
				<div className="text-center mb-3">
					<Image
					src={bakeryLogoUrl}
					alt="Bakery Logo"
					style={{
						maxHeight: "80px",
						objectFit: "contain",
						marginBottom: "6px",
					}}
					/>
					<h4 style={{ margin: 0 }}>
					{bakeryPrettyName}
					</h4>
				</div>
				)}


				<Card className="shadow-sm" style={{ borderRadius: "15px" }}>
					<Card.Body style={{ padding: "30px" }}>
						<Row>
							{/* LEFT SIDE - FORM */}
							<Col md={6}>
								<h5>Generic Quote Request </h5>
								<Accordion defaultActiveKey="0">
									{/* Tier Preferences */}
									<Accordion.Item eventKey="0">
										<Accordion.Header>Tier Preferences</Accordion.Header>
										<Accordion.Body>
											<Form.Group>
												<Form.Label># of Tiers</Form.Label>
												<Form.Select
													value={numTiers}
													onChange={(e) => setNumTiers(Number(e.target.value))}>
													{[...tierOptions]?.sort((a, b) => a - b).map((tier) => (
														<option key={tier} value={tier}>
														{tier}
														</option>
													))}
													</Form.Select>
											</Form.Group>
											<Form.Group className="mt-3">
												<Form.Label className="fw-bold">Tier Shape</Form.Label>
												<Form.Select
													value={tierShape}
													onChange={(e) => setTierShape(e.target.value)}>
													{tierShapeOptions?.map((shape) => (
														<option key={shape} value={shape}>
															{shape}
														</option>
													))}
												</Form.Select>
											</Form.Group>
										</Accordion.Body>
									</Accordion.Item>

									{/* Cake & Icing Flavors */}
									<Accordion.Item eventKey="1">
										<Accordion.Header>Cake & Icing Flavors</Accordion.Header>
										<Accordion.Body>
											{Array.from({ length: numTiers }, (_, i) => (
												<div key={i} className="mb-3 p-3 border rounded">
													<h5 className="fw-bold">Tier {i + 1}</h5>

													<Form.Group className="mt-2">
														<Form.Label className="fw-bold">Cake Flavor</Form.Label>
														<br></br>
														<Form.Text muted>Select from pre-set options:</Form.Text>
														<Form.Select
															className="mb-2"
															value={cakeFlavors[i + 1]?.selected || ""}
															onChange={(e) => {
															handleCakeFlavorChange(i + 1, {
																selected: e.target.value,
																custom: ""
															});
															}}
														>
															<option value="">-- Choose a flavor --</option>
															{cakeFlavorOptions.map((flavor) => (
															<option key={flavor} value={flavor}>
																{flavor}
															</option>
															))}
														</Form.Select>

														<Form.Text muted>Or add your own custom flavor:</Form.Text>
														<div className="d-flex gap-2">
															<Form.Control
															type="text"
															placeholder="Enter custom flavor..."
															value={cakeFlavors[i + 1]?.custom || ""}
															onChange={(e) => {
																const customFlavor = e.target.value;
																handleCakeFlavorChange(i + 1, {
																selected: customFlavor,
																custom: customFlavor
																});
															}}
															/>
															<Button
															variant="outline-secondary"
															onClick={() => {
																const flavorToAdd = cakeFlavors[i + 1]?.custom?.trim();
																if (
																flavorToAdd &&
																!cakeFlavorOptions.includes(flavorToAdd)
																) {
																setCakeFlavorOptions((prev) => [...prev, flavorToAdd]);
																// Set dropdown to the new flavor
																handleCakeFlavorChange(i + 1, {
																	selected: flavorToAdd,
																	custom: flavorToAdd
																});
																}
															}}
															>
															Add to dropdown
															</Button>
														</div>
														</Form.Group>



													{/* Filling Flavor */}
													<Form.Group className="mt-2">
													<Form.Label className="fw-bold">Filling Flavor</Form.Label>
													<Form.Text muted>Select from pre-set options:</Form.Text>
													<Form.Select
														className="mb-2"
														value={fillingFlavors[i + 1]?.selected || ""}
														onChange={(e) => {
														handleFillingFlavorChange(i + 1, {
															selected: e.target.value,
															custom: ""
														});
														}}
													>
														<option value="">-- Choose a flavor --</option>
														{fillingFlavorOptions.map((flavor) => (
														<option key={flavor} value={flavor}>
															{flavor}
														</option>
														))}
													</Form.Select>
													<Form.Text muted>Or add your own custom filling flavor:</Form.Text>
													<div className="d-flex gap-2">
														<Form.Control
														type="text"
														placeholder="Enter custom flavor..."
														value={fillingFlavors[i + 1]?.custom || ""}
														onChange={(e) => {
															const customFlavor = e.target.value;
															handleFillingFlavorChange(i + 1, {
															selected: customFlavor,
															custom: customFlavor
															});
														}}
														/>
														<Button
														variant="outline-secondary"
														onClick={() => {
															const flavorToAdd = fillingFlavors[i + 1]?.custom?.trim();
															if (flavorToAdd && !fillingFlavorOptions.includes(flavorToAdd)) {
															setFillingFlavorOptions((prev) => [...prev, flavorToAdd]);
															handleFillingFlavorChange(i + 1, {
																selected: flavorToAdd,
																custom: flavorToAdd
															});
															}
														}}
														>
														Add to dropdown
														</Button>
													</div>
													</Form.Group>

													{/* Icing Flavor */}
													<Form.Group className="mt-2">
													<Form.Label className="fw-bold">Icing Flavor</Form.Label>
													<Form.Text muted>Select from pre-set options:</Form.Text>
													<Form.Select
														className="mb-2"
														value={icingFlavors[i + 1]?.selected || ""}
														onChange={(e) => {
														handleIcingFlavorChange(i + 1, {
															selected: e.target.value,
															custom: ""
														});
														}}
													>
														<option value="">-- Choose a flavor --</option>
														{icingFlavorOptions.map((flavor) => (
														<option key={flavor} value={flavor}>
															{flavor}
														</option>
														))}
													</Form.Select>
													<Form.Text muted>Or add your own custom icing flavor:</Form.Text>
													<div className="d-flex gap-2">
														<Form.Control
														type="text"
														placeholder="Enter custom flavor..."
														value={icingFlavors[i + 1]?.custom || ""}
														onChange={(e) => {
															const customFlavor = e.target.value;
															handleIcingFlavorChange(i + 1, {
															selected: customFlavor,
															custom: customFlavor
															});
														}}
														/>
														<Button
														variant="outline-secondary"
														onClick={() => {
															const flavorToAdd = icingFlavors[i + 1]?.custom?.trim();
															if (flavorToAdd && !icingFlavorOptions.includes(flavorToAdd)) {
															setIcingFlavorOptions((prev) => [...prev, flavorToAdd]);
															handleIcingFlavorChange(i + 1, {
																selected: flavorToAdd,
																custom: flavorToAdd
															});
															}
														}}
														>
														Add to dropdown
														</Button>
													</div>
													</Form.Group>



													{/* ✅ "Apply to All" Button - Appears ONLY under Tier 1 */}
													{i === 0 && numTiers > 1 && (
														<Button
															variant="outline-primary"
															className="mt-2"
															onClick={() => {
																const tier1Cake = cakeFlavors[1] || "";
																const tier1Icing = icingFlavors[1] || "";
																const tier1Filling = fillingFlavors[1] || "";

																// Prevent applying empty selections
																if (!tier1Cake || !tier1Icing) {
																	alert(
																		"Please select both a cake and icing flavor for Tier 1 first.",
																	);
																	return;
																}

																// ✅ Ensure React recognizes the state change
																setCakeFlavors((prev) => {
																	const updatedCakeFlavors = { ...prev };
																	for (let j = 2; j <= numTiers; j++) {
																		updatedCakeFlavors[j] = { ...tier1Cake };
																	}
																	return { ...updatedCakeFlavors }; // ✅ Ensure new object reference
																});

																setIcingFlavors((prev) => {
																	const updatedIcingFlavors = { ...prev };
																	for (let j = 2; j <= numTiers; j++) {
																		updatedIcingFlavors[j] = tier1Icing; // ✅ Update all tiers
																	}
																	return { ...updatedIcingFlavors }; // ✅ Ensure new object reference
																});

																setFillingFlavors((prev) => {
																	const updatedFillingFlavors = { ...prev };
																	for (let j = 2; j <= numTiers; j++) {
																		updatedFillingFlavors[j] = tier1Filling; // ✅ Update all tiers
																	}
																	return { ...updatedFillingFlavors }; // ✅ Ensure new object reference
																});
															}}>
															Apply Tier 1 Selection to All
														</Button>
													)}
												</div>
											))}
										</Accordion.Body>
									</Accordion.Item>

									{/* Dietary Restrictions */}
									
									<Accordion.Item eventKey="2">
										<Accordion.Header>Dietary Restrictions</Accordion.Header>
										<Accordion.Body>
											<Form.Group>
											<Form.Label className="fw-bold">Select or add restrictions</Form.Label>
											<Select
												isMulti
												options={availableDietaryRestrictions.map((option) => ({
												value: option,
												label: option,
												}))}
												value={selectedDietaryRestrictions}
												onChange={setSelectedDietaryRestrictions}
												placeholder="Choose dietary restrictions..."
											/>

											<div className="d-flex gap-2 mt-3">
												<Form.Control
												type="text"
												placeholder="Enter a custom restriction..."
												value={customDietaryRestriction}
												onChange={(e) => setCustomDietaryRestriction(e.target.value)}
												/>
												<Button
												variant="outline-secondary"
												onClick={() => {
													const trimmed = customDietaryRestriction.trim();
													if (
													trimmed &&
													!availableDietaryRestrictions.includes(trimmed)
													) {
													setAvailableDietaryRestrictions((prev) => [...prev, trimmed]);
													setSelectedDietaryRestrictions((prev) => [
														...prev,
														{ label: trimmed, value: trimmed },
													]);
													setCustomDietaryRestriction("");
													}
												}}
												>
												Add
												</Button>
											</div>
											</Form.Group>
										</Accordion.Body>
										</Accordion.Item>

										


										<Accordion.Item eventKey="3">
											<Accordion.Header>Location / Date</Accordion.Header>
											<Accordion.Body>
												<Form.Group>
												
												<Form.Control
													as="textarea"
													rows={3}
													placeholder="Tomball, TX, May 9 2025"
													value={decorations[0] || ""}
													onChange={(e) => setDecorations([e.target.value])}
												/>
												</Form.Group>
											</Accordion.Body>
											</Accordion.Item>

								</Accordion>

								<Form.Group className="mt-3">
									<Form.Label>Design Notes / Additional Requests</Form.Label>
									<Form.Control
										as="textarea"
										rows={3}
										value={designNotes}
										onChange={(e) => setDesignNotes(e.target.value)}
									/>
								</Form.Group>
								<Form.Group className="mt-3 mb-5">
									<Form.Label>Sample Photo(s)</Form.Label>
									<InputFileWrapper id="sample-photos">
										<Form.Control
										id="sample-photos"
										type="file"
										style={{ display: "none" }}
										multiple
										accept="image/*"
										onChange={(e) => {
											const files = Array.from(e.target.files).slice(0, 5); // max 5
											setSamplePhotoFiles(files);
											setSamplePhotoPreviews(files.map((file) => URL.createObjectURL(file)));
										}}
										/>
									</InputFileWrapper>

									<Row className="mt-3">
										{samplePhotoPreviews.map((url, index) => (
										<Col key={index} xs={6} md={4} className="mb-3 position-relative">
											<CloseButton
											style={{ position: "absolute", right: 10, top: 5, zIndex: 2 }}
											onClick={() => {
												const updatedFiles = [...samplePhotoFiles];
												const updatedPreviews = [...samplePhotoPreviews];
												updatedFiles.splice(index, 1);
												updatedPreviews.splice(index, 1);
												setSamplePhotoFiles(updatedFiles);
												setSamplePhotoPreviews(updatedPreviews);
											}}
											/>
											<Image
											src={url}
											rounded
											style={{ width: "100%", height: "200px", objectFit: "cover" }}
											/>
										</Col>
										))}
									</Row>
									</Form.Group>


								{userSub ? (
									<Button
									onClick={handleSubmitQuote}
									disabled={isSubmitting}
									style={{
									  backgroundColor: '#FEA2C2',
									  border: 'none',
									  color: 'white',
									  fontWeight: 'bold',
									  padding: '12px 24px',
									  fontSize: '1.1rem',
									  borderRadius: '8px',
									  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
									  transition: 'all 0.3s ease-in-out',
									  opacity: isSubmitting ? 0.6 : 1,
									  cursor: isSubmitting ? 'not-allowed' : 'pointer',
									}}
								  >
									{isSubmitting ? "Submitting..." : "🎂 Submit Quote Request"}
								  </Button>								  
								) : (
									<Row>
										<Col>
										<h5 className="mt-4">Contact Information</h5>

										<Form.Group controlId="guestEmail" className="mt-2">
										<Form.Label>Email <span className="text-danger">*</span></Form.Label>
										<Form.Control
											type="email"
											placeholder="Enter your email"
											required
											value={guestEmail}
											onChange={(e) => setGuestEmail(e.target.value)}
											isInvalid={guestEmailTouched && !guestEmail}
											onBlur={() => setGuestEmailTouched(true)}
										/>
										<Form.Control.Feedback type="invalid">
											Email is required.
										</Form.Control.Feedback>
										</Form.Group>

										<Form.Group controlId="guestPhone" className="mt-2">
										<Form.Label>Phone Number (Optional)</Form.Label>
										<Form.Control
											type="tel"
											placeholder="Enter your phone number"
											value={guestPhone}
											onChange={(e) => setGuestPhone(e.target.value)}
										/>
										</Form.Group>
										<br></br>
										<Button
											onClick={handleSubmitQuote}
											disabled={isSubmitting}
											style={{
												backgroundColor: '#FEA2C2',
												border: 'none',
												color: 'white',
												fontWeight: 'bold',
												padding: '12px 24px',
												fontSize: '1.1rem',
												borderRadius: '8px',
												boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
												transition: 'all 0.3s ease-in-out',
												opacity: isSubmitting ? 0.6 : 1,
												cursor: isSubmitting ? 'not-allowed' : 'pointer',
											}}
											>
											{isSubmitting ? "Submitting..." : "🎂 Submit Quote Request"}
											</Button>

										</Col>
										{/* <Col>
											<Button
												onClick={() => {
													navigate("/register-form");
												}}
												className="mt-3">
												Create an Account
											</Button>
										</Col> */}
									</Row>
								)}
							</Col>

							{/* RIGHT SIDE - CAKE IMAGE & SUMMARY */}
							<Col md={6} className="text-center">
							<img
								src={`/${numTiers}tier_${tierShape.toLowerCase()}.png`}
								alt={`${numTiers} Tier Cake`}
								style={{
									width: "220px", // 👈 shrink this if needed
									height: "auto",
									marginBottom: "16px",
									borderRadius: "10px",
									display: "block",
									marginLeft: "auto",
									marginRight: "auto",
								}}
								/>


								<h4 >${getPriceEstimate()}</h4>
								<h5>{getTotalServings()} Servings</h5>
								{/* Cake & Icing Breakdown */}
							
								<div className="mt-4 text-start">
									<h5 className="fw-bold">Cake & Icing Breakdown:</h5>
									<ul className="list-unstyled">
										{Array.from({ length: numTiers }, (_, i) => (
											<li key={i} className="mb-2">
												<strong>Tier {i + 1}:</strong>
												<span className="text-muted">
													{" "}
													{cakeFlavors[i + 1]?.custom?.trim() || cakeFlavors[i + 1]?.selected || "Not selected"} cake, {" "}
													{fillingFlavors[i + 1]?.custom?.trim() || fillingFlavors[i + 1]?.selected || "Not selected"} filling, {" "}
													{icingFlavors[i + 1]?.custom?.trim() || icingFlavors[i + 1]?.selected || "Not selected"} icing
												</span>
											</li>
										))}
									</ul>
								</div>
								

								{/* Dietary Restrictions */}
								{selectedDietaryRestrictions.length > 0 && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Dietary Restrictions:</h5>
										<p className="text-muted">
											{selectedDietaryRestrictions.map((d) => d.label).join(", ")}
										</p>
									</div>
								)}

								{/* Decorations */}
								{decorations.length > 0 && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Location / Date:</h5>
										<p className="text-muted">
										{decorations.join(", ")}
										</p>
									</div>
								)}

								{/* Design Notes */}
								{designNotes && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Additional Design Notes:</h5>
										<p className="text-muted">{designNotes}</p>
									</div>
								)}
							</Col>
						</Row>
					</Card.Body>
				</Card>
				<Row className="mt-5">
				
				</Row>

			</Container>
		);
};

export default GenericQuoteRequest;
